import { API_URL } from "@/shared/api/apiUrl";
import { sendRequest } from "@/shared/api/requestSender";
import { HttpMethod } from "@/shared/types";

// Temporary here
export const sendCreateCartRequest = () =>
  sendRequest({
    path: API_URL.clientOrders.createCart,
    method: HttpMethod.POST,
  });

// Temporary here
export const sendAddItemToCartRequest = (
  orderId: string,
  body: {
    sampleId: number;
    quantity?: number;
  }
) =>
  sendRequest({
    path: `${API_URL.clientOrders.addItemToCart.start}${orderId}${API_URL.clientOrders.addItemToCart.end}`,
    method: HttpMethod.POST,
    data: body,
  });

export const sendAddInfectiousItemToCartRequest = (
  orderId: string,
  body: {
    infectiousAliquotId: number;
  }
) =>
  sendRequest({
    path: `${API_URL.clientOrders.addInfectiousItemToCart.start}${orderId}${API_URL.clientOrders.addInfectiousItemToCart.end}`,
    method: HttpMethod.POST,
    data: body,
  });

// Temporary here
export const sendRemoveItemFromCartRequest = (
  orderId: string,
  body: { sampleId: number; quantity?: number }
) =>
  sendRequest({
    path: `${API_URL.clientOrders.removeItemFromCart.start}${orderId}${API_URL.clientOrders.removeItemFromCart.end}`,
    method: HttpMethod.POST,
    data: body,
  });

export const sendRemoveInfectiousItemFromCartRequest = (
  orderId: string,
  body: { infectiousAliquotId: number }
) =>
  sendRequest({
    path: `${API_URL.clientOrders.removeInfectiousItemFromCart.start}${orderId}${API_URL.clientOrders.removeInfectiousItemFromCart.end}`,
    method: HttpMethod.POST,
    data: body,
  });

export const sendGetInfectiousOrderItemsRequest = (orderId: string) =>
  sendRequest({
    path: `${API_URL.clientOrders.infectiousOrderItems.start}${orderId}${API_URL.clientOrders.infectiousOrderItems.end}`,
    method: HttpMethod.GET,
  });

export const sendRemoveAllItemFromCartRequest = (
  orderId: string,
) =>
  sendRequest({
    path: `${API_URL.clientOrders.removeAllItemFromCart.start}${orderId}${API_URL.clientOrders.removeAllItemFromCart.end}`,
    method: HttpMethod.DELETE,
  });

// Temporary here
export const sendPlaceOrderRequest = (
  orderId: string,
  body: {
    sampleId: number;
    quantity?: number;
    carrier?: string;
    paymentMethod?: string;
    shippingLocationId?: number;
    purchaseOrderNumber?: string;
    postalAccountId?: number;
    forTestingPurpose?: boolean;
  }
) =>
  sendRequest({
    path: `${API_URL.clientOrders.placeOrder.start}${orderId}${API_URL.clientOrders.placeOrder.end}`,
    method: HttpMethod.POST,
    data: body,
  });

export const sendPresignedImageUrlRequest = (body: Partial<any> | unknown) =>
  sendRequest({
    path: API_URL.utils.presignedUrl,
    method: HttpMethod.POST,
    data: body,
  });
